import React from 'react';
import Tag from '../Tag';

interface IProps {
  value: string;
}
const TagOption = ({ value }: IProps) => <Tag label={value} isReadOnly></Tag>;

export default React.memo(TagOption);
